import { CustomerOrder } from '@/@types/responses/customer_order/CustomerOrder'
import { CustomerOrderDetails } from '@/@types/responses/customer_order/CustomerOrderDetails'
import { PagingResponse } from '@/@types/responses/common/PagingResponse'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class CustomerOrderService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public getCustomerOrder(id: number): Promise<CustomerOrderDetails> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/customer-orders/${id}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return new CustomerOrderDetails(json.id, json.buildSteps, json.buildTypeName, json.cartridgeName, json.customer, json.customerSuppliedParts, json.parts, json.partsDiscountPercentage, json.payments, json.scheduledDate, json.services, json.servicesDiscountPercentage, json.total)
    })
  }

  public searchCustomerOrders(
    pageNumber: number,
    pageSize: number,
    sortField: string,
    buildTypeId: number|undefined,
    cartridgeId: number|undefined,
    ascending: boolean,
    isScheduled: boolean): Promise<PagingResponse<CustomerOrder>> {
    let queryString = `?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&ascending=${ascending}`

    if (buildTypeId)
      queryString += `&buildTypeId=${buildTypeId}`

    if (cartridgeId)
      queryString += `&cartridgeId=${cartridgeId}`

    if (isScheduled)
      queryString += '&isScheduled=true'

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/customer-orders${queryString}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as PagingResponse<CustomerOrder>
    })
  }
}
